import { VexRoutes } from '../../../../@vex/interfaces/vex-route.interface';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { QuicklinkModule } from 'ngx-quicklink'; // Désactivé - incompatible Angular 14
import { ProductComponent } from './product/product.component';
import { EstablishmentComponent } from './establishment/establishment.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserProfileDetailsResumeComponent } from './user-profile/user-profile-details/user-profile-details-resume/user-profile-details-resume.component';
import { UserProfileDetailsComponent } from './user-profile/user-profile-details/user-profile-details.component';
import { SupplierComponent } from './supplier/supplier.component';
import { SupplierDetailsComponent } from './supplier/supplier-details/supplier-details.component';
import { SupplierDetailsResumeComponent } from './supplier/supplier-details/supplier-details-resume/supplier-details-resume.component';
import { SupplierDetailsContactComponent } from './supplier/supplier-details/supplier-details-contact/supplier-details-contact.component';
import { PrestationComponent } from './prestation/prestation.component';
import { BuildingComponent } from './building/building.component';
import { BuildingDetailsResumeComponent } from './building/building-details/building-details-resume/building-details-resume.component';
import { BuildingDetailsDocumentComponent } from './building/building-details/building-details-document/building-details-document.component';
import { BuildingDetailsComponent } from './building/building-details/building-details.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { ProductDetailsComponent } from './product/product-details/product-details.component';
import { ProductDetailsResumeComponent } from './product/product-details/product-details-resume/product-details-resume.component';
import { EstablishmentDetailsComponent } from './establishment/establishment-details/establishment-details.component';
import { EstablishmentDetailsResumeComponent } from './establishment/establishment-details/establishment-details-resume/establishment-details-resume.component';
import { EstablishmentDetailsAnalyticsComponent } from './establishment/establishment-details/establishment-details-analytics/establishment-details-analytics.component';
import { EstablishmentDetailsContactComponent } from './establishment/establishment-details/establishment-details-contact/establishment-details-contact.component';
import { EstablishmentDetailsActiviteComponent } from './establishment/establishment-details/establishment-details-activite/establishment-details-activite.component';
import { BuildingDetailsRoomComponent } from './building/building-details/building-details-room/building-details-room.component';
import { EquipmentDetailsComponent } from './equipment/equipment-details/equipment-details.component';
import { EquipmentDetailsResumeComponent } from './equipment/equipment-details/equipment-details-resume/equipment-details-resume.component';
import { ContractComponent } from './contract/contract.component';
import { ContractDetailsComponent } from './contract/contract-details/contract-details.component';
import { ContractDetailsResumeComponent } from './contract/contract-details/contract-details-resume/contract-details-resume.component';
import { SupplierDetailsDocumentsComponent } from './supplier/supplier-details/supplier-details-documents/supplier-details-documents.component';
import { EquipmentDetailsDocumentsComponent } from './equipment/equipment-details/equipment-details-documents/equipment-details-documents.component';
import { EquipmentDetailsServiceBookComponent } from './equipment/equipment-details/equipment-details-service-book/equipment-details-service-book.component';
import { UserProfileDetailsRolesComponent } from './user-profile/user-profile-details/user-profile-details-roles/user-profile-details-roles.component';
import { PermissionGuard } from '../../../core/guards/permission.guard';
import { ENUM_PERMISSIONS } from '../../../core/enums/permission.enum';
import { UserProfileDetailsTechnicalAssignationComponent } from './user-profile/user-profile-details/user-profile-details-technical-assignation/user-profile-details-technical-assignation.component';
import { EstablishmentDetailsBuildingsComponent } from './establishment/establishment-details/establishment-details-buildings/establishment-details-buildings.component';
import { SupplierDetailsClientNumberComponent } from './supplier/supplier-details/supplier-details-code/supplier-details-client-number.component';
import { SupplierDetailsApiComponent } from './supplier/supplier-details/supplier-details-api/supplier-details-api.component';
import { SupplierDetailsApiTesterComponent } from './supplier/supplier-details/supplier-details-api-tester/supplier-details-api-tester.component';
import { SupplierApiTesterGuard } from './supplier/supplier-api-tester.guard';
import { EstablishmentDetailsValidatorsComponent } from './establishment/establishment-details/establishment-details-validators/establishment-details-validators.component';
import { EstablishmentDetailsSupervisionComponent } from './establishment/establishment-details/establishment-details-supervision/establishment-details-supervision.component';
import { ContractDetailsCgaComponent } from './contract/contract-details/contract-details-cga/contract-details-cga.component';
import { ContractDetailsCatalogComponent } from './contract/contract-details/contract-details-catalog/contract-details-catalog.component';
import { ContractDetailsBasketContractComponent } from './contract/contract-details/contract-details-basket-contract/contract-details-basket-contract.component';
import { EnergyIdComponent } from './energy-id/energy-id.component';
import { ContractDetailsPerimeterComponent } from './contract/contract-details/contract-details-perimeter/contract-details-perimeter.component';
import { EstablishmentDetailsDocumentsComponent } from './establishment/establishment-details/establishment-details-documents/establishment-details-documents.component';
import { EstablishmentDetailsNeedsComponent } from './establishment/establishment-details/establishment-details-needs/establishment-details-needs.component';
import { DescriptionHotTopicComponent } from '../administrative/hot-topic/description/description-hot-topic.component';
import { ContractHotTopicComponent } from '../administrative/hot-topic/contract/contract-hot-topic.component';
import { EstablishmentDetailsPrestationNeedsComponent } from './establishment/establishment-details/establishment-details-needs/establishment-details-prestation-needs/establishment-details-prestation-needs.component';
import { EstablishmentDetailsProductNeedsComponent } from './establishment/establishment-details/establishment-details-needs/establishment-details-product-needs/establishment-details-product-needs.component';
import { ContractDetailsCatalogInternComponent } from './contract/contract-details/contract-details-catalog-intern/contract-details-catalog-intern.component';

// Maquette d'estimation « action d'équipe » (branche d'estimation, jamais fusionnée)
import { TeamActionMockTeamsPageComponent } from '../administrative/team-action-mock/app/teams-page/team-action-mock-teams-page.component';
import { TeamActionMockTeamPageComponent } from '../administrative/team-action-mock/app/team-page/team-action-mock-team-page.component';
import { TeamActionMockEstablishmentTeamsTabComponent } from '../administrative/team-action-mock/app/establishment-teams-tab/team-action-mock-establishment-teams-tab.component';

const routes: VexRoutes = [
  {
    path: '',
    redirectTo: 'establishment',
    pathMatch: 'full',
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
    // PRED-3232 a levé la restriction au périmètre d'établissements de l'utilisateur (visibilité sur
    // tous les contacts), pas la permission de rôle : l'écran reste soumis à READ_INTERNAL_CONTACT.
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT,
    },
  },
  {
    path: 'user-profile/:id',
    component: UserProfileDetailsComponent,
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT,
    },
    children: [
      {
        path: '',
        component: UserProfileDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_INFORMATION,
        },
      },
      {
        path: 'technical-assignation',
        component: UserProfileDetailsTechnicalAssignationComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_PERIMETER,
        },
      },
      {
        path: 'roles',
        component: UserProfileDetailsRolesComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT_ROLES,
        },
      },
    ],
  },
  // Maquette d'estimation « action d'équipe » : menu Équipes (données fictives)
  {
    path: 'teams',
    component: TeamActionMockTeamsPageComponent,
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT,
    },
  },
  {
    path: 'teams/:teamId',
    component: TeamActionMockTeamPageComponent,
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_INTERNAL_CONTACT,
    },
  },
  {
    path: 'establishment',
    component: EstablishmentComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
  },
  {
    path: 'establishment/:id',
    component: EstablishmentDetailsComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
    children: [
      {
        path: '',
        component: EstablishmentDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_INFORMATION,
        },
      },
      {
        path: 'contact',
        component: EstablishmentDetailsContactComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_CONTACT,
        },
      },
      {
        path: 'activite',
        component: EstablishmentDetailsActiviteComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_ACTIVITY,
        },
      },
      {
        path: 'needs',
        component: EstablishmentDetailsNeedsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS,
        },
        children: [
          {
            path: '',
            component: EstablishmentDetailsProductNeedsComponent,
            data: {
              permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS,
            },
          },
          {
            path: 'prestations',
            component: EstablishmentDetailsPrestationNeedsComponent,
            canActivate: [PermissionGuard],
            data: {
              permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS,
            },
          },
        ],
      },
      // Maquette d'estimation « action d'équipe » : onglet ÉQUIPES des fonctions support (données fictives)
      {
        path: 'teams',
        component: TeamActionMockEstablishmentTeamsTabComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT,
        },
      },
      {
        path: 'analytics',
        component: EstablishmentDetailsAnalyticsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_ANALYTIC_PLAN,
        },
      },
      {
        path: 'buildings',
        component: EstablishmentDetailsBuildingsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_BUILDINGS,
        },
      },
      {
        path: 'validators',
        component: EstablishmentDetailsValidatorsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.ESTABLISHMENT_READ_PURCHASE_ACTORS,
        },
      },
      {
        path: 'supervision',
        component: EstablishmentDetailsSupervisionComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_SUPERVISION,
        },
      },
      {
        path: 'validators/:id',
        component: EstablishmentDetailsValidatorsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.ESTABLISHMENT_READ_PURCHASE_ACTORS,
        },
      },
      {
        path: 'documents',
        component: EstablishmentDetailsDocumentsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_GED,
        },
      },
    ],
  },
  {
    path: 'energy-id',
    component: EnergyIdComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
  },
  {
    path: 'building',
    component: BuildingComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_BUILDING,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
  },
  {
    path: 'building/:id',
    component: BuildingDetailsComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_BUILDING,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
    children: [
      {
        path: '',
        component: BuildingDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_BUILDING_INFORMATION,
        },
      },
      {
        path: 'room',
        component: BuildingDetailsRoomComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_BUILDING_ROOM,
        },
      },
      {
        path: 'document',
        component: BuildingDetailsDocumentComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_BUILDING_GED,
        },
      },
    ],
  },
  {
    path: 'product',
    component: ProductComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_PRODUCT,
    },
  },
  {
    path: 'product/:id',
    component: ProductDetailsComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
    children: [
      {
        path: '',
        component: ProductDetailsResumeComponent,
      },
    ],
  },
  {
    path: 'prestation',
    component: PrestationComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_SERVICE,
    },
  },
  {
    path: 'equipment',
    component: EquipmentComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_EQUIPMENT,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
  },
  {
    path: 'equipment/:id',
    component: EquipmentDetailsComponent,
    canActivate: [PermissionGuard],
    data: {
      permission: ENUM_PERMISSIONS.READ_EQUIPMENT,
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
    children: [
      {
        path: '',
        component: EquipmentDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_EQUIPMENT_INFORMATION,
        },
      },
      {
        path: 'service-book',
        component: EquipmentDetailsServiceBookComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_EQUIPMENT_SERVICE_BOOK,
        },
      },
      {
        path: 'documents',
        component: EquipmentDetailsDocumentsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_EQUIPMENT_GED,
          toolbarShadowEnabled: true,
          containerEnabled: true,
        },
      },
    ],
  },
  {
    path: 'supplier',
    component: SupplierComponent,
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_SUPPLIER,
    },
  },
  {
    path: 'supplier/:id',
    component: SupplierDetailsComponent,
    canActivate: [PermissionGuard],
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
      permission: ENUM_PERMISSIONS.READ_SUPPLIER,
    },
    children: [
      {
        path: '',
        component: SupplierDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_SUPPLIER_INFORMATION,
        },
      },
      {
        path: 'contact',
        component: SupplierDetailsContactComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_SUPPLIER_CONTACT,
        },
      },
      {
        path: 'document',
        component: SupplierDetailsDocumentsComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_SUPPLIER_GED,
        },
      },
      {
        path: 'client-number',
        component: SupplierDetailsClientNumberComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_SUPPLIER_CLIENT_NUMBER,
        },
      },
      {
        path: 'api',
        component: SupplierDetailsApiComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_SUPPLIER_API,
        },
      },
      {
        path: 'api-test',
        component: SupplierDetailsApiTesterComponent,
        canActivate: [SupplierApiTesterGuard],
      },
    ],
  },
  {
    path: 'engagement',
    component: ContractComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
  },
  {
    path: 'engagement/:id',
    component: ContractDetailsComponent,
    data: {
      toolbarShadowEnabled: true,
      containerEnabled: true,
    },
    children: [
      {
        path: '',
        component: ContractDetailsResumeComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_INFORMATION,
        },
      },
      {
        path: 'perimeter',
        component: ContractDetailsPerimeterComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_PERIMETER,
        },
      },
      {
        path: 'cga',
        component: ContractDetailsCgaComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_CGA,
        },
      },
      {
        path: 'catalog',
        component: ContractDetailsCatalogComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_CATALOG,
        },
      },
      {
        path: 'internalCatalog',
        component: ContractDetailsCatalogInternComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_CATALOG,
        },
      },
      {
        path: 'basket-contract',
        component: ContractDetailsBasketContractComponent,
        canActivate: [PermissionGuard],
        data: {
          permission: ENUM_PERMISSIONS.READ_CONTRACT_BASKET,
        },
      },
    ],
  },
  // {
  //     path: 'user/:id',
  //     component: UserDetailsComponent,
  //     data: {
  //         toolbarShadowEnabled: true
  //     },
  //     children: [
  //         {
  //             path: '',
  //             component: UserDetailsResumeComponent
  //         },
  //         {
  //             path: 'other',
  //             component: UserDetailsOtherComponent
  //         }
  //     ]
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagementRoutingModule {}
